export const AccessorActionTypes = {
  UPDATE_ACCESSOR: "UPDATE_ACCESSOR",
};
